"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PlayerTimer_vue_1 = require("@/client/components/overview/PlayerTimer.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'player-status',
    props: {
        timer: {
            type: Object,
            required: true,
        },
        actionLabel: {
            type: String,
            required: true,
        },
        showTimer: {
            type: Boolean,
        },
        liveTimer: {
            type: Boolean,
        },
    },
    components: {
        PlayerTimer: PlayerTimer_vue_1.default,
    },
    methods: {
        getLabelAndTimerClasses() {
            const classes = [];
            const baseClass = 'player-action-status-container';
            classes.push(baseClass);
            if (!this.showTimer) {
                classes.push('no-timer');
            }
            if (this.actionLabel === 'passed') {
                classes.push(`${baseClass}--passed`);
            }
            else if (this.actionLabel === 'active' || this.actionLabel === 'drafting' || this.actionLabel === 'researching') {
                classes.push(`${baseClass}--active`);
            }
            return classes.join(' ');
        },
        getActionStatusClasses() {
            const classes = ['player-action-status'];
            if (this.actionLabel === 'none') {
                classes.push('visibility-hidden');
            }
            return classes.join(' ');
        },
    },
});
